import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import tw from 'twin.macro';
import Burger from '../../../atom/Icon/SVG/Burger';
import Dashboard from '../../../atom/Icon/SVG/Dashboard';
import useTranslator from '../../../../hook/common/useTranslator/useTranslator.hook';

type Props = {
  onMenuClick(): void;
};

const Header = tw.header`fixed top-0 left-0 right-0 z-40 flex h-14 items-center justify-between px-4 bg-white border-b border-gray-100 md:hidden`;
const HamburgerButton = tw.button`flex items-center justify-center w-9 h-9 -ml-1 rounded-lg hover:bg-gray-100 transition-colors`;
const PageTitle = tw.span`text-base font-semibold text-gray-800 font-inter`;
const DashboardButton = tw.button`flex items-center justify-center w-9 h-9 -mr-1 rounded-lg text-primary-500 hover:bg-gray-100 transition-colors`;

const PATH_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  organization: 'Organization',
  user: 'User',
};

function getPageTitle(pathname: string) {
  const firstSegment = pathname.split('/')[1] ?? '';
  return PATH_LABELS[firstSegment] ?? 'Menu';
}

export default function MobileHeader({ onMenuClick }: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const translator = useTranslator();

  return (
    <Header>
      <HamburgerButton onClick={onMenuClick} aria-label='Open Menu'>
        <Burger />
      </HamburgerButton>
      <PageTitle>{translator.translate(getPageTitle(pathname))}</PageTitle>
      <DashboardButton
        aria-label='Dashboard'
        onClick={() => navigate('/dashboard')}
      >
        <Dashboard width={20} height={20} fill='#175882' />
      </DashboardButton>
    </Header>
  );
}
